import { MetadataField } from '../../../../../../constnats/reportConstants';
import { DIFF_TYPE } from '../../../../../../constnats/diff';
import type { ReportType } from '../../../../../../schemas/report.schemas';
import type { DescriptorPairType, PropDiffChangedType } from '../../../../../../schemas/schemaDiff.schemas';
import DescriptorUtils from '../../../../../../utils/descriptor/descriptorUtils';
import { REPORT_CELL_DIFF_KIND, REPORT_FIELD_DIFF_PROPERTY } from './constants';
import type {
    DescriptorWithDiffType,
    ReportCellDiffKind,
    ReportDiffCellData,
    ReportWithDiffType,
} from './types';

export function buildReportDiffCellData(
    descriptor: DescriptorWithDiffType,
    report: ReportWithDiffType,
    descriptorPair: DescriptorPairType,
    fieldDifferences?: Record<string, PropDiffChangedType>,
    referenceReport?: ReportType,
): ReportDiffCellData {
    const fields: Record<string, unknown> = DescriptorUtils.isDynamic(descriptor) ? report.dynamicFields : report;
    const { referenceDescriptor, targetDescriptor } = descriptorPair;
    const valueDescriptorId = report.diffType === DIFF_TYPE.REMOVED ? referenceDescriptor : targetDescriptor;
    let differenceKind: ReportCellDiffKind | undefined;

    if (fieldDifferences) {
        if (fieldDifferences[REPORT_FIELD_DIFF_PROPERTY.CORE_VALUE]) {
            const targetManuallyCalculated = targetDescriptor !== null
                && report.metadata.fieldSpecific[targetDescriptor]?.[MetadataField.MANUALLY_CALCED] === true;
            const referenceManuallyCalculated = referenceDescriptor !== null
                && referenceReport?.metadata.fieldSpecific[referenceDescriptor]?.[MetadataField.MANUALLY_CALCED] === true;
            differenceKind = targetManuallyCalculated && referenceManuallyCalculated
                ? REPORT_CELL_DIFF_KIND.CALCULATED_VALUE
                : REPORT_CELL_DIFF_KIND.VALUE;
        } else {
            differenceKind = REPORT_CELL_DIFF_KIND.OTHER;
        }
    }

    return {
        value: valueDescriptorId === null ? '' : String(fields[valueDescriptorId] ?? ''),
        referenceDescriptorId: referenceDescriptor,
        targetDescriptorId: targetDescriptor,
        reportDiffType: report.diffType,
        differenceKind,
        differences: fieldDifferences,
    };
}
